// @flow
import {combineReducers} from 'redux';
import {consoleReducer} from './console';
import type {TConsoleState} from './console';
import {consoleInfoReducer} from 'modules/console/reducers/console-info';
import type {TConsoleInfoState} from 'modules/console/reducers/console-info';

const reducers = {
    console: consoleReducer,
    consoleInfo: consoleInfoReducer,
};

type TConsoleModuleState = {
    console: TConsoleState,
    consoleInfo: TConsoleInfoState,
};

const consoleModuleReducer = combineReducers(reducers);
export {consoleModuleReducer};
export type {TConsoleModuleState};
